import React from 'react';
import styles from './Decloration.module.css';
import moment from "moment/moment";
import Button from "@mui/material/Button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";

const normalizeStatus = (declaration) => {
    // Try common API shapes first
    const rawStatus =
        declaration?.status?.name ||
        declaration?.status?.title ||
        declaration?.status_name ||
        declaration?.application_status?.name ||
        declaration?.application_status?.title ||
        declaration?.application_status ||
        declaration?.status ||
        null;

    if (rawStatus) {
        return String(rawStatus);
    }

    // Fallback to previous behaviour based on activity flag
    return declaration?.application_type?.is_active ? 'Принято в работу' : 'Закрыто';
};

const getStatusStyle = (statusLabel, isActive) => {
    const normalized = statusLabel?.toLowerCase() || '';

    // отказ (rejection/refusal) - light red
    if (
        normalized.includes('отказ') ||
        normalized.includes('отказан') ||
        normalized.includes('отклон') ||
        normalized.includes('не соглас') ||
        normalized.includes('не принято')
    ) {
        return { background: '#FFE5E3', color: '#EF2E25' };
    }

    // принято (accepted) - light green
    if (normalized.includes('принято') || normalized.includes('принят')) {
        return { background: '#E2EEDD', color: '#A1C261' };
    }

    // в работе (in progress) - light blue
    if (normalized.includes('в работе') || normalized.includes('работа') || normalized.includes('обработ')) {
        return { background: '#E8EFFB', color: '#2F6FED' };
    }

    // на доработку (needs revision) - light orange
    if (normalized.includes('доработ') || normalized.includes('доработа')) {
        return { background: '#FFE8E3', color: '#F36D52' };
    }

    // Fallback for closed/inactive
    if (normalized.includes('закры') || !isActive) {
        return { background: '#FFE5E3', color: '#EF2E25' };
    }

    // Default fallback - light green
    return { background: '#E2EEDD', color: '#A1C261' };
};

const DeclarationList = ({ declaration }) => {
    const navigate = useNavigate();
    const createdAt = moment(declaration.created_at);
    const now = moment();
    const duration = moment.duration(now.diff(createdAt));

    const days = Math.floor(duration.asDays());
    const hours = Math.floor(duration.asHours() % 24);
    const formattedTime = days > 0
        ? `${days} дней и ${hours} часов назад`
        : `${hours} часов назад`;

    const statusLabel = normalizeStatus(declaration);
    const statusStyle = getStatusStyle(statusLabel, declaration?.application_type?.is_active);
    const isNeedsRevision = statusLabel.toLowerCase().includes('доработ');
    const isRejected =
        statusLabel.toLowerCase().includes('отказ') ||
        statusLabel.toLowerCase().includes('отказан') ||
        statusLabel.toLowerCase().includes('отклон');
    const adminComment = (() => {
        const raw =
            declaration?.revision_comment ||
            declaration?.revision_comment_text ||
            declaration?.admin_comment ||
            null;
        if (raw == null) return null;
        const text = String(raw).trim();
        return text || null;
    })();
    const showAdminComment = Boolean(adminComment) && (isNeedsRevision || isRejected);

    const handleCopyApplication = (e) => {
        e.stopPropagation();
        if (declaration.application_type?.id) {
            navigate(`/declarations/${declaration.application_type.id}?copyFrom=${declaration.id}`);
        }
    };

    const handleEditAndResubmit = (e) => {
        e.stopPropagation();
        if (declaration.application_type?.id) {
            navigate(`/declarations/${declaration.application_type.id}?editFrom=${declaration.id}`);
        }
    };

    return (
        <>
            <div
                style={!declaration.application_type.is_active ? { color: '#8F9191' } : {}}
                className={styles.list}
            >
                <span className={styles.id}>#{declaration.id} </span>
                <div style={{ flex: 1 }}>
                    <span>{declaration.application_name}</span>
                    <div className={styles.listBody}>
                        <div className={styles.status} style={statusStyle}>
                            {statusLabel}
                        </div>
                        <span className={styles.listTime} style={{ fontSize: '12px' }}>{formattedTime}</span>
                    </div>
                    {showAdminComment && (
                        <div className={styles.listComment}>
                            {adminComment}
                        </div>
                    )}
                </div>
                <Button
                    onClick={isNeedsRevision ? handleEditAndResubmit : handleCopyApplication}
                    size="small"
                    startIcon={isNeedsRevision ? <EditIcon /> : <ContentCopyIcon />}
                    style={{
                        minWidth: 'auto',
                        padding: '4px 8px',
                        fontSize: '12px',
                        textTransform: 'none',
                        color: '#666',
                        marginLeft: '10px',
                        border: 'none',
                        boxShadow: 'none',
                        textDecoration: 'none',
                        cursor: 'pointer'
                    }}
                    variant="text"
                >
                    {isNeedsRevision ? 'Исправить и отправить' : 'Копировать'}
                </Button>
            </div>
        </>
    );
};

export default DeclarationList;